<div [ngClass]="backdropClasses">
    <div [ngClass]="containerClasses">
        <!-- Header -->
        <div
            class="px-4 py-2.5 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white flex items-center justify-between shrink-0 entry-modal-header">
            <div class="flex items-center gap-3">
                <div
                    class="w-8 h-8 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-sm entry-modal-icon">
                    <svg class="w-4 h-4 text-white entry-modal-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <div>
                    <h3 class="font-bold text-base text-gray-900 entry-modal-title">New Time Entry</h3>
                    <div class="flex items-center gap-2 text-sm text-gray-500">
                        <svg class="w-4 h-4 hidden entry-modal-time-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span class="font-medium">{{ editedStartDate | date:'HH:mm' }}</span>
                        <span class="text-gray-400">→</span>
                        <span class="font-medium">{{ editedEndDate | date:'HH:mm' }}</span>
                        <span class="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full ml-1">
                            {{ durationText }}
                        </span>
                    </div>
                </div>
            </div>
            <button (click)="cancel.emit()"
                class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <!-- Content -->
        <div class="flex-1 overflow-y-auto min-h-0 flex flex-col entry-modal-content">

            <!-- Left panel - Activity list -->
            <!-- Hidden on small screens when empty, always visible on lg+ -->
            <div class="w-full border-b border-gray-100 flex flex-col bg-gray-50/50 shrink-0 entry-modal-left activity-panel"
                [class.activity-panel--empty]="allTimelineActivity.length === 0 && !isLoading">
                <div class="px-4 py-2 border-b border-gray-100 flex items-center gap-2 entry-modal-left-header">
                    <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                    <h4 class="text-sm font-semibold text-gray-700">Available Activities</h4>
                    <span class="text-xs text-gray-400 ml-auto">Click to link</span>
                </div>
                <div class="overflow-y-auto p-3 custom-scrollbar max-h-[25vh] entry-modal-left-body">
                    @if(isLoading) {
                    <div class="flex items-center justify-center py-4 entry-modal-loading">
                        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                    </div>
                    } @else {
                    <div class="flex flex-col gap-2">
                        @for(activity of allTimelineActivity; track activity.id ){
                        <div class="p-2 rounded-xl cursor-pointer flex justify-between items-center transition-all duration-200 border group entry-modal-activity-item"
                            (click)="addSelectedActivity(activity)" [ngClass]="isSelected(activity)
                                    ? 'bg-blue-600 text-white border-blue-700 shadow-md'
                                    : 'bg-white text-gray-700 border-gray-200 hover:bg-blue-50 hover:border-blue-200'">
                            <div class="flex items-center gap-2 min-w-0">
                                @if(isSelected(activity)) {
                                <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M5 13l4 4L19 7" />
                                </svg>
                                }
                                <span class="font-medium text-sm truncate">{{ activity.title }}</span>
                            </div>
                            <span class="text-xs whitespace-nowrap px-2 py-1 rounded-lg flex-shrink-0"
                                [ngClass]="isSelected(activity) ? 'bg-white/20' : 'bg-gray-100 text-gray-500'">
                                @if(activity.duration > 60){ {{ activity.duration / 60 | number:'1.0-0' }}m }
                                @else{ {{ activity.duration }}s }
                            </span>
                        </div>
                        } @empty {
                        <!-- Empty state: compact on small, original on lg -->
                        <div class="flex flex-col items-center justify-center py-3 text-gray-400 entry-modal-empty-state">
                            <svg class="w-5 h-5 mb-0 text-gray-300 entry-modal-empty-icon" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                            </svg>
                            <span class="text-sm">No activity for this time</span>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>

            <!-- Right panel - Form -->
            <div class="w-full flex flex-col custom-scrollbar p-3 gap-2.5 bg-white entry-modal-right">

                <!-- Source switcher — Project / Task -->
                <div class="flex items-center gap-1 p-1 bg-gray-100 rounded-xl">
                    <button type="button" (click)="switchSource('project')"
                        class="flex-1 py-1.5 px-3 rounded-lg text-sm font-medium transition-all duration-200"
                        [class]="entrySource === 'project' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
                        <span class="flex items-center justify-center gap-1.5">
                            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                            </svg>
                            Project
                        </span>
                    </button>
                    <button type="button" (click)="switchSource('crm')"
                        class="flex-1 py-1.5 px-3 rounded-lg text-sm font-medium transition-all duration-200"
                        [class]="entrySource === 'crm' ? 'bg-blue-600 text-white shadow-sm' : 'text-gray-500 hover:text-gray-700'">
                        <span class="flex items-center justify-center gap-1.5">
                            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                            </svg>
                            Task
                        </span>
                    </button>
                </div>

                <!-- Project mode -->
                @if (entrySource === 'project') {

                <!-- Project — searchable dropdown, alphabetical -->
                <!-- `relative` sits OUTSIDE the clipping frame: overflow-hidden on the
                     positioning context would clip the dropdown panel away entirely. -->
                <div class="relative" (focusout)="onProjectDropdownFocusOut($event)">
                    <div class="border border-gray-200 rounded-lg overflow-hidden">
                    <label
                        class="block px-3 py-1.5 bg-gray-50 text-[10px] entry-modal-label font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Project</label>
                    <button type="button" (click)="toggleProjectDropdown()"
                        class="w-full px-3 py-2 bg-white entry-modal-select cursor-pointer focus:ring-2 focus:ring-blue-400/50 outline-none transition-all border-0 text-sm text-left flex items-center justify-between gap-2">
                        <span class="truncate" [class.text-gray-400]="!selectedProjectId">
                            {{ selectedProjectLabel || 'Select a project' }}
                        </span>
                        <svg class="w-4 h-4 text-gray-400 shrink-0 transition-transform"
                            [class.rotate-180]="projectDropdownOpen" fill="none" stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                    </div>

                    @if(projectDropdownOpen) {
                    <div class="absolute left-0 right-0 top-full z-[100] bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden">
                        <!-- Search -->
                        <div class="relative border-b border-gray-100">
                            <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input #projectSearchInput type="text" [(ngModel)]="projectSearch"
                                (ngModelChange)="filterProjects()" placeholder="Search projects…"
                                class="w-full pl-8 pr-3 py-2 text-sm bg-white focus:outline-none" />
                        </div>
                        <!-- List -->
                        <div class="max-h-48 overflow-y-auto custom-scrollbar">
                            @if(filteredProjects.length === 0) {
                            <p class="text-center text-xs text-gray-400 py-6">No project found</p>
                            }
                            @for(project of filteredProjects; track project.projectId){
                            <button type="button" (mousedown)="selectProject(project)"
                                class="w-full text-left px-3 py-2 text-sm cursor-pointer border-b border-gray-50 last:border-0 transition-colors flex items-center gap-2"
                                [class]="selectedProjectId === project.projectId ? 'bg-blue-50 text-blue-700' : 'hover:bg-gray-50 text-gray-700'">
                                <span class="flex-1 truncate">
                                    {{ project.projectName }}
                                    <span class="text-xs text-gray-400">({{ project.tenant?.name || 'No tenant' }})</span>
                                </span>
                                @if(selectedProjectId === project.projectId) {
                                <svg class="w-3.5 h-3.5 text-blue-500 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clip-rule="evenodd" />
                                </svg>
                                }
                            </button>
                            }
                        </div>
                    </div>
                    }
                </div>

                <!-- Stage — searchable dropdown -->
                @if(filteredStages.length > 0) {
                <div class="relative animate-fade-in" (focusout)="onStageDropdownFocusOut($event)">
                    <div class="border border-gray-200 rounded-lg overflow-hidden">
                    <label
                        class="block px-3 py-1.5 bg-gray-50 text-[10px] entry-modal-label font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Stage</label>
                    <button type="button" (click)="toggleStageDropdown()"
                        class="w-full px-3 py-2 bg-white entry-modal-select cursor-pointer focus:ring-2 focus:ring-blue-400/50 outline-none transition-all border-0 text-sm text-left flex items-center justify-between gap-2">
                        <span class="truncate" [class.text-gray-400]="!selectedStageId">
                            {{ selectedStageLabel || 'Select a stage' }}
                        </span>
                        <svg class="w-4 h-4 text-gray-400 shrink-0 transition-transform"
                            [class.rotate-180]="stageDropdownOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                    </div>

                    @if(stageDropdownOpen) {
                    <div class="absolute left-0 right-0 top-full z-[100] bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden">
                        <div class="relative border-b border-gray-100">
                            <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input #stageSearchInput type="text" [(ngModel)]="stageSearch"
                                (ngModelChange)="filterStageSearch()" placeholder="Search phases…"
                                class="w-full pl-8 pr-3 py-2 text-sm bg-white focus:outline-none" />
                        </div>
                        <div class="max-h-48 overflow-y-auto custom-scrollbar">
                            @if(searchedStages.length === 0) {
                            <p class="text-center text-xs text-gray-400 py-6">No phase found</p>
                            }
                            @for(stage of searchedStages; track stage.projectStageId){
                            <button type="button" (mousedown)="selectStage(stage)"
                                class="w-full text-left px-3 py-2 text-sm cursor-pointer border-b border-gray-50 last:border-0 transition-colors flex items-center gap-2"
                                [class]="selectedStageId === stage.projectStageId ? 'bg-blue-50 text-blue-700' : 'hover:bg-gray-50 text-gray-700'">
                                <span class="flex-1 truncate">
                                    {{ stage.stageName }}
                                    <span class="text-xs text-gray-400">({{ getStatusText(stage.status) }})</span>
                                </span>
                                @if(selectedStageId === stage.projectStageId) {
                                <svg class="w-3.5 h-3.5 text-blue-500 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clip-rule="evenodd" />
                                </svg>
                                }
                            </button>
                            }
                        </div>
                    </div>
                    }
                </div>
                }

                <!-- Task — open only by default, switch to all. Rendered whenever a phase
                     is selected, so an empty phase can still offer quick creation. -->
                @if(selectedStageId) {
                <!-- Same shape as the Project picker: `relative` outside, clipping frame
                     inside, panel as a sibling of the frame. -->
                <div class="relative animate-fade-in" (focusout)="onTaskDropdownFocusOut($event)">
                    <div class="border border-gray-200 rounded-lg overflow-hidden">
                    <div class="flex items-center justify-between gap-2 px-3 py-1.5 bg-gray-50 border-b border-gray-200">
                        <label
                            class="text-[10px] entry-modal-label font-semibold text-gray-500 uppercase tracking-wide">Task</label>
                        @if(stageTasks.length > 0) {
                        <div class="flex items-center bg-gray-200/70 rounded-md p-0.5">
                            <button type="button" (click)="setTaskStatusFilter('open')"
                                class="px-2 py-0.5 text-[10px] font-semibold rounded transition-all cursor-pointer"
                                [class]="taskStatusFilter === 'open' ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Open</button>
                            <button type="button" (click)="setTaskStatusFilter('all')"
                                class="px-2 py-0.5 text-[10px] font-semibold rounded transition-all cursor-pointer"
                                [class]="taskStatusFilter === 'all' ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
                                All @if(doneTaskCount > 0){({{ stageTasks.length }})}
                            </button>
                        </div>
                        }
                    </div>
                    <button type="button" (click)="toggleTaskDropdown()"
                            class="w-full px-3 py-2 bg-white entry-modal-select cursor-pointer focus:ring-2 focus:ring-blue-400/50 outline-none transition-all border-0 text-sm text-left flex items-center justify-between gap-2">
                            <span class="truncate" [class.text-gray-400]="!selectedTaskId">
                                {{ selectedTaskLabel || 'Select a task' }}
                            </span>
                            <svg class="w-4 h-4 text-gray-400 shrink-0 transition-transform"
                                [class.rotate-180]="taskDropdownOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                            </svg>
                    </button>
                    </div>

                    @if(taskDropdownOpen) {
                        <div class="absolute left-0 right-0 top-full z-[100] bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden">
                            <div class="relative border-b border-gray-100">
                                <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" fill="none"
                                    stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                                <input #taskSearchInput type="text" [(ngModel)]="taskSearch"
                                    (ngModelChange)="filterTaskSearch()" placeholder="Search tasks…"
                                    class="w-full pl-8 pr-3 py-2 text-sm bg-white focus:outline-none" />
                            </div>

                            <div class="max-h-48 overflow-y-auto custom-scrollbar">
                                @if(searchedTasks.length === 0) {
                                <p class="text-center text-xs text-gray-400 py-5">
                                    @if(taskSearch.trim()) { No task matches “{{ taskSearch }}” }
                                    @else if(doneTaskCount > 0) { No open task — switch to <span class="font-semibold text-gray-500">All</span>. }
                                    @else { No task in this phase yet }
                                </p>
                                }
                                @for(task of searchedTasks; track task.id){
                                <button type="button" (mousedown)="selectTask(task)"
                                    class="w-full text-left px-3 py-2 text-sm cursor-pointer border-b border-gray-50 last:border-0 transition-colors flex items-center gap-2"
                                    [class]="selectedTaskId === task.id ? 'bg-blue-50 text-blue-700' : 'hover:bg-gray-50 text-gray-700'">
                                    <span class="flex-1 truncate">
                                        {{ task.nameTask }}
                                        @if(task.status){ <span class="text-xs text-gray-400">({{ getStatusText(task.status) }})</span> }
                                    </span>
                                    @if(selectedTaskId === task.id) {
                                    <svg class="w-3.5 h-3.5 text-blue-500 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    }
                                </button>
                                }
                            </div>

                            <!-- Quick create: a phase without a task used to block the whole entry -->
                            <div class="border-t border-gray-100 bg-gray-50/70">
                                @if(!creatingTask) {
                                <button type="button" (mousedown)="$event.preventDefault(); startCreatingTask()"
                                    class="w-full flex items-center gap-2 px-3 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 transition-colors cursor-pointer">
                                    <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                                    </svg>
                                    @if(taskSearch.trim()) { Create “{{ taskSearch }}” } @else { Create a task }
                                </button>
                                } @else {
                                <div class="flex items-center gap-2 p-2">
                                    <input #newTaskInput type="text" [(ngModel)]="newTaskName" placeholder="Task name"
                                        (keydown.enter)="$event.preventDefault(); createQuickTask()"
                                        (keydown.escape)="cancelCreatingTask()"
                                        class="flex-1 min-w-0 px-2 py-1.5 text-sm border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-blue-400/50" />
                                    <button type="button" (mousedown)="$event.preventDefault(); createQuickTask()"
                                        [disabled]="!newTaskName.trim() || isSavingTask"
                                        class="px-2.5 py-1.5 bg-blue-600 text-white text-xs font-semibold rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer shrink-0">
                                        @if(isSavingTask) { … } @else { Add }
                                    </button>
                                    <button type="button" (mousedown)="$event.preventDefault(); cancelCreatingTask()"
                                        class="px-2 py-1.5 bg-gray-200 text-gray-600 text-xs rounded-md hover:bg-gray-300 cursor-pointer shrink-0">&#10005;</button>
                                </div>
                                }
                            </div>
                        </div>
                    }
                </div>
                }

                } @else {

                <!-- CRM Task mode -->
                <div class="border border-gray-200 rounded-lg overflow-hidden">
                    <label
                        class="block px-3 py-1.5 bg-gray-50 text-[10px] entry-modal-label font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Task</label>
                    <!-- Search -->
                    <div class="relative border-b border-gray-100">
                        <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input type="text" [(ngModel)]="crmTaskSearch" (ngModelChange)="onCrmSearch()"
                            placeholder="Search tasks…"
                            class="w-full pl-8 pr-3 py-2 text-sm bg-white focus:outline-none" />
                    </div>
                    <!-- List -->
                    <div class="max-h-48 overflow-y-auto">
                        @if (filteredCrmTasks.length === 0) {
                        <p class="text-center text-xs text-gray-400 py-6">No tasks assigned to you</p>
                        }
                        @for (task of filteredCrmTasks; track task.id) {
                        <div (click)="selectedCrmTaskId = task.id"
                            class="flex items-center gap-2 px-3 py-2.5 cursor-pointer border-b border-gray-50 last:border-0 transition-colors"
                            [class]="selectedCrmTaskId === task.id ? 'bg-blue-50 text-blue-700' : 'hover:bg-gray-50 text-gray-700'">
                            <!-- Status indicator -->
                            <span class="flex-shrink-0 text-xs"
                                [class]="task.status === 'DONE' ? 'text-green-500' : task.status === 'IN_PROGRESS' ? 'text-blue-500' : 'text-gray-400'">
                                @if (task.status === 'DONE') { ✓ }
                                @else if (task.status === 'IN_PROGRESS') { ▶ }
                                @else { ○ }
                            </span>
                            <span class="text-sm font-medium flex-1 truncate">{{ task.name }}</span>
                            @if (selectedCrmTaskId === task.id) {
                            <svg class="w-3.5 h-3.5 text-blue-500 flex-shrink-0" fill="currentColor"
                                viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            }
                        </div>
                        }
                    </div>
                </div>

                } <!-- end source switch -->



                <!-- Description -->
                <div class="border border-gray-200 rounded-lg overflow-hidden">
                    <label
                        class="block px-3 py-1.5 bg-gray-50 text-[10px] entry-modal-label font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Description</label>
                    <textarea [(ngModel)]="content" rows="2"
                        class="w-full px-3 py-2 bg-white entry-modal-select resize-y focus:ring-2 focus:ring-blue-400/50 outline-none transition-all border-0 text-sm"
                        placeholder="What did you work on?"></textarea>
                </div>

                <!-- Time -->
                <div class="border border-gray-200 rounded-lg overflow-hidden">
                    <!-- Small: inline label + inputs. Large: stacked label + centered inputs -->
                    <label
                        class="block px-3 py-1.5 bg-gray-50 text-[10px] entry-modal-label font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Time</label>
                    <div class="flex items-center justify-center gap-4 px-3 py-2 bg-white entry-modal-time-row">
                        <!-- Start -->
                        <div class="flex items-center gap-1.5">
                            <input type="number" min="0" max="23" [ngModel]="editStartHour"
                                (ngModelChange)="updateTime('startH', +$event)" class="time-input" />
                            <span class="text-gray-400 font-bold text-lg">:</span>
                            <input type="number" min="0" max="59" [ngModel]="editStartMinute"
                                (ngModelChange)="updateTime('startM', +$event)" class="time-input" />
                        </div>
                        <span class="text-gray-400 font-medium text-base px-1">→</span>
                        <!-- End -->
                        <div class="flex items-center gap-1.5">
                            <input type="number" min="0" max="23" [ngModel]="editEndHour"
                                (ngModelChange)="updateTime('endH', +$event)" class="time-input" />
                            <span class="text-gray-400 font-bold text-lg">:</span>
                            <input type="number" min="0" max="59" [ngModel]="editEndMinute"
                                (ngModelChange)="updateTime('endM', +$event)" class="time-input" />
                        </div>
                    </div>
                </div>



                <!-- Images -->
                <!--                <div class="border border-gray-200 rounded-lg overflow-hidden">
                    <label class="block px-4 py-2 bg-gray-50 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-200">Attachments</label>
                    <div class="p-3 bg-white flex items-center gap-3">
                        <label for="entryFileInput"
                               class="px-4 py-2 rounded-md text-sm font-medium bg-gray-50 border border-gray-200
                                      text-gray-700 cursor-pointer hover:bg-gray-100 transition-all">
                            Choose files
                        </label>
                        <input id="entryFileInput" type="file" accept="image/*" multiple (change)="onFilesSelected($event)" hidden />
                        <span class="text-xs text-gray-500">
                            {{ selectedFiles.length > 0 ? selectedFiles.length + ' file(s) selected' : 'No files selected' }}
                        </span>
                    </div>
                </div>-->
            </div>
        </div>

        <!-- Footer -->
        <div class="px-3 py-2 bg-gray-50 entry-modal-footer flex justify-between items-center border-t border-gray-100 shrink-0">
            <!-- AI Button -->
            @if(this.posthogService.featureFlagAI()){
            <button (click)="askAi()" [disabled]="!selectedProjectId" class="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium
                           bg-indigo-50 text-indigo-600 border border-indigo-200
                           hover:bg-indigo-500 hover:text-white hover:border-indigo-500
                           disabled:opacity-50 transition-all cursor-pointer">
                <span>✨</span> Ask AI
            </button>
            } @else {
            <div></div>
            }

            <div class="flex flex-col items-end gap-2">
                <!-- Validation hint -->
                @if(!isFormValid()) {
                <div class="text-xs text-amber-600 flex items-center gap-1">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                    <span>Please fill:
                        @if (entrySource === 'project') {
                        @if(!selectedProjectId) { Project }
                        @if(!selectedStageId && selectedProjectId) { Phase }
                        @if(!selectedTaskId && selectedStageId) { Task }
                        @if(!content.trim() && selectedTaskId) { Description }
                        } @else {
                        @if(!selectedCrmTaskId) { a CRM Task }
                        @if(!content.trim() && selectedCrmTaskId) { Description }
                        }
                    </span>
                </div>
                }

                <div class="flex gap-3">
                    <button (click)="cancel.emit()" class="px-4 py-2 rounded-lg text-sm font-medium text-gray-600
                                   bg-white border border-gray-200 hover:bg-gray-50
                                   transition-all cursor-pointer">
                        Cancel
                    </button>
                    <button (click)="onSave()" [disabled]="!isFormValid()" class="inline-flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-medium text-white
                                   bg-blue-600 hover:bg-blue-700
                                   disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm
                                   focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        [class.cursor-pointer]="isFormValid()">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        Save Entry
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>